var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.isToday)?_c('span',[_vm._v(_vm._s(_vm.$t('WEBAPP_TODAY')))]):(_vm.isYesterday)?_c('span',[_vm._v(_vm._s(_vm.$t('WEBAPP_YESTERDAY')))]):_c('span',[_vm._v(_vm._s(_vm.$d(_vm._date, 'short')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }